import axios from 'axios';

import { ILicenseFile } from '@/shared/model/license-file.model';

const baseApiUrl = 'api/license-files';

export default class LicenseFileService {

  public retrieveByLicenseData(licenseDataId: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/license-data/${licenseDataId}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public download(licenseDataId: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      console.log(`${baseApiUrl}/download/${licenseDataId}`);
      axios
        .get(`${baseApiUrl}/download/${licenseDataId}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

}
